import { render, staticRenderFns } from "./ZigbeeDevice.vue?vue&type=template&id=88423f4a&scoped=true&"
import script from "./ZigbeeDevice.vue?vue&type=script&lang=js&"
export * from "./ZigbeeDevice.vue?vue&type=script&lang=js&"
import style0 from "./ZigbeeDevice.vue?vue&type=style&index=0&id=88423f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88423f4a",
  null
  
)

export default component.exports